import { Component, OnInit, Input } from "@angular/core";
import Swal from "sweetalert2";
import { AuthenticationService } from "src/app/services/authentication.service";
import { IUser } from "src/app/interface/user";
import { environment } from "src/environments/environment";
import { AssetAttributesService } from "../../services/asset-attributes.service";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { GenericLayerService } from "src/app/services/generic-layer.service";
import { CardViewService } from "src/app/services/card-view.service";
import { CustomTranslatePipe } from "../../shared/custom-translate.pipe";
import { SmsAutocomplete } from "src/app/shared/sms-autocomplete/sms-autocomplete.component";
import { MatOptionModule } from "@angular/material/core";
import { NgFor, NgIf } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ILayer } from "src/app/interface/layer";
import { EventEmittersService } from "src/app/services/event-emitters.service";

@Component({
    selector: "app-sms-asset-defaults",
    templateUrl: "./asset-defaults.component.html",
    styleUrls: ["./asset-defaults.component.scss"],
    styles: [],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, NgFor, MatOptionModule, NgIf, SmsAutocomplete, TranslateModule, CustomTranslatePipe]
})
export class AssetDefaultsComponent implements OnInit {
  @Input() FeatureTable: any;
  @Input() FeatureLayer: any;
  @Input() Query: any;
  @Input() QueryTask: any;
  @Input() map: any;
  @Input() Graphic: any;
  public adFeatureTable: any;
  public defaultsFeatureLayer: any;
  public materialValues: any[] = [];
  public add: any[] = [];
  public delete: any[] = [];
  public loading = true;
  public currentUser: IUser;
  public selectedLayerOID: number = -1;
  public tableAliases: any;
  public assetCodeDefaults: any[] = [];
  selectedRowIndex = -1;
  OnClicked: any[] = [];
  codeValues: any[] = [];
  DomainValues: any[] = [];
  //<!-- TSDRSAM-856 By Manikantha -->
  public filterVal: any;
  // public customerDiffer: KeyValueDiffer<any,any>;
  private assetCodeDefaultsOriginal: any;
  constructor(
    private authenticationService: AuthenticationService,
    private assetAttributesService: AssetAttributesService,
    private cardViewService: CardViewService,
    private translateService: TranslateService,
    private genericLayerService: GenericLayerService,
    private eeService: EventEmittersService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    this.defaultsFeatureLayer = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.assetCodeDefaultsId);
    this.getDomainAndTableAliasValues();
  }

  getDomainAndTableAliasValues() {
    try {
      this.assetAttributesService.getDomainValues().subscribe((res: any) => {

        //get domain values
        //only Material domain implemented at this time.  TODO implement other domain values as needed. TODO include columns as appropriate to the asset class (e.g. SheetType for Signs) and collect their domain values as well.
        this.DomainValues = res.domains.filter((Obj) => Obj.name.includes("_Material"));

        //get table alias values
        this.assetAttributesService.getTableAlias().subscribe((res: any) => {
          const tableAliasInfo = res.features;
          if (tableAliasInfo.length > 0) {
            this.tableAliases = [];
            const inventoryLayerNames: string[] = [] = this.eeService.userLayers.filter((lyr: ILayer) => lyr.type === "inventory").map( i => i.name );
            inventoryLayerNames.forEach((name) => {
              this.tableAliases.push( tableAliasInfo.find( (ta) => ta.attributes.Name === name).attributes );
              if (name === "Support") { 
                // if parent asset is included gather child asset alias info
                this.tableAliases.push(...tableAliasInfo.filter( (ta) => ta.attributes.GroupType === "Child Table").map(ta => ta.attributes));
              }
            });
            this.selectedLayerOID = this.tableAliases[0].OBJECTID;
            this.onChangeLayer(null);
          }
        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  save() {
    try {
      const changes = this.getChanges(this.assetCodeDefaultsOriginal, this.assetCodeDefaults);
      if (changes.length > 0) {
        const changedCodeDefaults: any[] = [];
        changes.forEach( (change) => {
          changedCodeDefaults.push(new this.Graphic().setAttributes(change));
        });
        this.defaultsFeatureLayer.applyEdits(null, changedCodeDefaults, null, 
          () => { Swal.fire(this.translateService.instant("Userscreens.alertassetdefaults.savededits")); },
          (err: any) => { Swal.fire(this.translateService.instant("Userscreens.alertassetdefaults.errortosave")); }
        );
      } else {
        Swal.fire(this.translateService.instant("Userscreens.alertassetdefaults.noeditstosave"));
      }
    } catch (error) {
      console.error(error);
    }
  }

  cancel(): void {
    this.selectedRowIndex = -1;
    this.OnClicked = [];
  }

  onChangeLayer(evt: any): void {
    try {
      this.cancel();
      this.filterVal = undefined;

      const selectedTableInfo = this.tableAliases.find( (td) => td.OBJECTID === this.selectedLayerOID );
      const materialDomain = this.DomainValues.find((obj) => obj.name === selectedTableInfo.LayerCode + "_Material" || obj.name === selectedTableInfo.Name + "_Material");
      this.codeValues = materialDomain ? materialDomain.codedValues : [];

      // get saved defaults for each asset code in the selected layer
      this.assetCodeDefaults = [];
      const defaultsURL = this.currentUser.webServiceURL + environment.mapServer + this.currentUser.tableIds.assetCodeDefaultsId;
      const QueryParams = "AssetShortName='" + selectedTableInfo.LayerCode + "'";
      this.cardViewService.getFeatures(defaultsURL, QueryParams, this.Query, this.QueryTask).then(
        (defaultsPerAssetCode: any) => {
          defaultsPerAssetCode.forEach((defaults) => {
            this.assetCodeDefaults.push(defaults.attributes);
          });
          this.assetCodeDefaultsOriginal = JSON.parse(JSON.stringify(this.assetCodeDefaults)); //clone
        }
      );
      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  }

  getChanges(oldArray: any, newArray: any): any[] {
    let i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return [];
    }
    const changes: any[] = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }
}
